(ns hai.tasks.assignee-bubble
  "The assignee circle on a My Tasks row. For an owner or admin, a click opens
   [[hai.tasks.assignee-picker]] to reassign the task; for anyone else it is
   the circle alone, which says why."
  (:require
   [hai.tasks.assignee-picker :as assignee-picker]
   [hai.tasks.data :as data]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private person-icon (icons/mui-icon :outlined :person))

;; Who the task is assigned to, as a circle of initials: violet for the
;; requester, orange for anyone else, and an empty dashed ring around the person
;; glyph for nobody.
(o/defstyled assignee-avatar :span
  {:display "inline-flex" :align-items "center" :justify-content "center"
   :flex "0 0 auto"
   :box-sizing "border-box"
   :width "26px" :height "26px"
   :border-radius "50%"
   :font-size "11px" :font-weight "700" :letter-spacing "0.02em"
   :user-select "none"}
  [:svg {:width "15px" :height "15px" :fill "currentColor"}]
  [:&.me
   {:background t/--card-violet-soft
    :color t/--card-violet}]
  [:&.other
   {:background t/--card-orange-soft
    :color t/--card-orange
    :border-width "1px" :border-style "solid" :border-color t/--card-orange-45}]
  [:&.nobody
   {:border-width "1px" :border-style "dashed" :border-color t/--note-sage-35
    :color t/--link-muted}]
  ([{:keys [assignee me?]}]
   [:<>
    {:class (cond
              (nil? assignee) "nobody"
              me? "me"
              :else "other")}
    (or (data/assignee-initials assignee) [person-icon])]))

;; The circle as the picker's trigger: ringed on hover and while the picker is
;; open, over the picker's own trigger ring.
(o/defstyled avatar-button :span
  {:display "inline-flex"}
  [:button:hover {:box-shadow "0 0 0 1.5px var(--card-forest)"}]
  ["[data-state=open] button" {:box-shadow "0 0 0 1.5px var(--card-forest)"}])

(defn component
  "`task`'s assignee circle. `change-fx` rides a reassignment's success."
  [{:keys [task change-fx]}]
  (let [assignee (:task/assigned-to task)
        current-user @(<s [:auth/identity])
        avatar [assignee-avatar {:assignee assignee
                                 :me? (and (some? assignee) (data/assignee-me? current-user assignee))}]]
    ;; The picker is portalled, but its clicks still bubble through the React
    ;; tree to the card.
    [avatar-button {:on-click #(.stopPropagation %)}
     (if (data/can-assign? task)
       [assignee-picker/component
        {:editable? true
         :label (if assignee
                  (str "Assigned to " (data/assignee-name assignee))
                  "Unassigned")
         :on-pick (fn [picked]
                    (>e [::data/assign (:task/uuid task) picked change-fx]))
         :trigger avatar}]
       [:span {:title "Only the owner or an admin can reassign this task"}
        avatar])]))
